/**
 * Full page load, as opposed to a React Router `navigate()`. Re-bootstraps the
 * store from the URL — which is what makes `?variant=` and `?version=` take
 * effect, since they are only read when the store is created.
 */
export const hardReload = (url: string) => {
  window.location.href = url;
};
